import type { ReactNode } from "react";
import { cn } from "@/shared/lib/utils";

interface SafeAreaProps {
  children: ReactNode;
  className?: string;
}

/**
 * Full-height container that respects iOS safe area insets.
 * All screens should be wrapped in this.
 */
export function SafeArea({ children, className }: SafeAreaProps) {
  return (
    <div
      className={cn(
        "flex flex-col h-full",
        // Apply safe area via CSS env() variables
        "pt-[env(safe-area-inset-top)]",
        "pb-[env(safe-area-inset-bottom)]",
        "pl-[env(safe-area-inset-left)]",
        "pr-[env(safe-area-inset-right)]",
        className
      )}
    >
      {children}
    </div>
  );
}
